const demo = {
    host: {
        api: "https://f62hq43ybi.execute-api.ap-northeast-2.amazonaws.com/demo"
    },
    playerEndpoint: "http://mzc-cm-demo-players.s3-website.ap-northeast-2.amazonaws.com/",
    deployDestination: "s3://mzc-cm-demo-shared-videos",
    profile: "mzc-media-demo"
};

export default demo;